<template>
  <FooterButton
      type="Save"
      :disabled="!enabled"
      @save="clickOnButton"
      data-test-path="save-and-close-button"
      :long-size="true"
      :label=" mode === 'NEW' ? (partiallySavedNew ? RETRY_ADD_AND_CLOSE_LABEL: ADD_AND_CLOSE_LABEL) : SAVE_AND_CLOSE_LABEL"
  >
    <template v-slot:icon>
      <font-awesome-layers>
        <font-awesome-icon icon="caret-left" transform="shrink-0 left-7" />
        <font-awesome-icon icon="save" transform="shrink-0 right-5 down-0"  />
      </font-awesome-layers>
    </template>
  </FooterButton>
</template>

<script>


import FooterButton from "@/components/navbar/FooterButton";

export default {
  name: "SaveAndCloseButton",
  components: {FooterButton},
  methods: {
    clickOnButton() {
      this.$emit("save");
    },
  },

  props: {
    clicked:            Function,
    partiallySavedNew: {type: Boolean, default: false},
    mode: {type: String, default: "EDIT"},

    enabled:         {type: Boolean, default: true},
  },

  data: () => ({
    RETRY_ADD_AND_CLOSE_LABEL:$tr("RetryAdd","Retry add"),
    ADD_AND_CLOSE_LABEL:$tr("add","Add"),
    SAVE_AND_CLOSE_LABEL:$tr("Save","Save")
  })

}
</script>


